import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";

import { pathGenerators } from "utils/routes";

import { ResultCorrectionBadge } from "../../components/ResultCorrectionBadge/ResultCorrectionBadge";
import { formatCommonDate } from "../../utils/formatters";
import styles from "./columns.module.css";
import { TruncatedTestNames } from "./TruncatedTestNames";

const TestNames = ({ result: row }) => {
  const hasTestNames = row.results?.some((r) => r.testName);

  if (hasTestNames) {
    return (
      <span>
        {row.results.map((r, i) => (
          <span key={i} className={r.warning ? styles.warningText : undefined}>
            {r.testName}
            {i !== row.results.length - 1 && ", "}
          </span>
        ))}
      </span>
    );
  }

  // Fall back to test names list, then the message type.
  return (
    <span>
      {row.testNamesList?.filter(Boolean).join(", ") || row.resultType || "-"}
    </span>
  );
};

export const getRadiologyStaffColumns = ({ navigateToPatient }) => [
  {
    id: "date",
    header: "Date",
    width: "100px",
    render: (row) => formatCommonDate(row.orderDate),
  },
  {
    id: "patient",
    header: "Patient",
    width: "130px",
    flexGrow: 1,
    render: (row) => {
      const name = row.patient
        ? `${row.patient.firstName} ${row.patient.surname}`
        : row.patientInformationExternal?.fullName || "Unknown Patient";

      return row.patientId ? (
        <Link
          to={pathGenerators.patient.results(row.patientId)}
          className={styles.patientName}
          onClick={(e) => navigateToPatient(e, row.patientId)}
        >
          {name}
        </Link>
      ) : (
        <span>{name}</span>
      );
    },
  },
  {
    id: "test",
    header: "Test",
    width: "216px",
    render: (row) => (
      <span className={styles.testCell}>
        <TruncatedTestNames>
          <TestNames result={row} />
        </TruncatedTestNames>
        <ResultCorrectionBadge result={row} />
      </span>
    ),
  },
  {
    id: "status",
    header: "",
    width: "20px",
    render: (row) =>
      row.orderStatus === "CONFIRMED" ? (
        <CheckCircle size={16} className={styles.confirmedIcon} />
      ) : null,
  },
];
